import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { enableWebhookRegistrationQuery } from '../apis';

const useEnableWebhookRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: enableWebhookRegistrationQuery,
    onSuccess: () => {
      toast.success('Webhook registration enabled');
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'detail'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Failed to enable webhook registration';
      toast.error(message);
    },
  });
};

export default useEnableWebhookRegistration;
